import PropTypes from "prop-types";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import ReactPlayer from "react-player";

const { REACT_APP_GENERATOR_MINIO_ENDPOINT } =
  typeof window !== "undefined" && window.env ? window.env : process.env;

const AttachMedium = ({
  partnerType,
  attachVideoStep,
  attachedAt,
  completeAt,
}) => {
  const path = `${REACT_APP_GENERATOR_MINIO_ENDPOINT}/${partnerType}/attaching.mp4`;
  const videoRef = useRef(null);
  const steps = ["initial", "attaching", "attached", "rotating", "complete"];
  const [step, setStep] = useState(attachVideoStep);

  useEffect(() => {
    setStep(attachVideoStep);
  }, [attachVideoStep]);

  const stepsSettings = {
    initial: {
      startTime: 0,
      endTime: 0,
      play: false,
    },
    attaching: {
      startTime: 0,
      endTime: attachedAt,
      play: true,
    },
    attached: {
      startTime: attachedAt,
      endTime: attachedAt,
      play: false,
    },
    rotating: {
      startTime: attachedAt,
      endTime: completeAt,
      play: true,
    },
    complete: {
      startTime: completeAt,
      endTime: completeAt,
      play: false,
    },
  };
  const handleNext = () => {
    setStep((currentStep) => {
      const indexOfStep = steps.indexOf(currentStep);
      let nextStep = "initial";
      if (indexOfStep === steps.length - 1) {
        nextStep = steps[0];
        videoRef.current.seekTo(stepsSettings[nextStep].startTime, "seconds");
      } else {
        nextStep = steps[indexOfStep + 1];
      }
      return nextStep;
    });
  };

  return (
    <>
      <ReactPlayer
        ref={videoRef}
        width="100%"
        height="auto"
        url={path}
        controls={false}
        loop={false}
        muted={true}
        playing={stepsSettings[step].play}
        playsinline
        config={{
          file: {
            attributes: {
              controlsList: "nodownload noplaybackrate",
              disablePictureInPicture: true,
            },
          },
        }}
        progressInterval={100}
        onProgress={({ playedSeconds }) => {
          if (
            stepsSettings[step].play &&
            playedSeconds >= stepsSettings[step].endTime
          ) {
            handleNext();
          }
        }}
      />
    </>
  );
};

AttachMedium.contextTypes = {
  t: PropTypes.func,
};

AttachMedium.propTypes = {
  partnerType: PropTypes.string.isRequired,
  attachedAt: PropTypes.number,
  completeAt: PropTypes.number,
  attachVideoStep: PropTypes.string.isRequired,
};

AttachMedium.defaultProps = {
  attachedAt: 8.9,
  completeAt: 24.5,
};

export default AttachMedium;
